<template>
  <Loader v-if="loading" />
  <div v-else>
    <BaseFormGroup>
      <BaseFormLabel :for="`${_uid}-form-id`"> Form * </BaseFormLabel>

      <BaseFormSelect
        :value="defaultData.form_id"
        :options="options"
        :id="`${_uid}-form-id`"
        @input="setProps"
      />
    </BaseFormGroup>
  </div>
</template>

<script>
import { projectFormsClient } from '@/api/clients';

export default {
  props: {
    projectUuid: { type: String, required: true },
    defaultData: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      options: [],
    };
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.loading = true;

      try {
        const { data = {} } = await projectFormsClient.list(this.projectUuid);

        if (data && data.data) {
          this.options = data.data.map(({ uuid, name }) => ({ label: name, value: uuid }));
        }
      } catch (error) {
        //
      }

      this.loading = false;
    },

    setProps(formId) {
      if (!formId) this.$emit('update-props', null);

      this.$emit('update-props', { form_id: formId });
    },
  },
};
</script>
